import {
    createSelector
} from "reselect";

export const productCostsSelector = createSelector(state => state && state.productCosts && state.productCosts.productCosts, productCostsSelector => productCostsSelector)